import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideInvitationForm from '../containers/CareGuideInvitationFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideInvitationAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideInvitationAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_invitation_route_add')} />
          <CareGuideInvitationForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideInvitationAddScreen;

Logger.log('silly', `CareGuideInvitationAddScreen loaded.`);
